export default ['.redirect-case-attendance']
